export default __webpack_public_path__ + "static/Instarvision.blackberry.app_01-27997bf6b46991322b31a8951ab90cc4.webp";